// extracted by mini-css-extract-plugin
export default {"body":"AnswerFeedbackModal-module__body--d75b0","footer":"AnswerFeedbackModal-module__footer--c96c8 Modals-module__footer--e47b9"};